import { render, staticRenderFns } from "./ShowFullForm.vue?vue&type=template&id=1cb3e42a"
import script from "./ShowFullForm.vue?vue&type=script&lang=ts"
export * from "./ShowFullForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports